export default {
    name: 'José Rafael',
    surname: 'Gutierrez Blanco',
    short_name: 'José R. Gutierrez',
    gender: 'Masculino',
    activities: ['Desarrollador Web', 'Diseñador UI/UX', 'Matemático', 'Freelancer'],
    birthday: '1981-10-05',
}